import React, { useRef, useState } from 'react'

import clsx from 'clsx'

import HoverEvent from 'components/HoverEvent/HoverEvent'
import { formatRatingAverage } from 'helpers/formatters'
import { useIsomorphicLayoutEffect } from 'hooks'

import RatingBreakdownLink from './components/RatingBreakdownLink'

import classes from './RatingBreakdownTooltip.module.scss'

const RATINGMAPPING = {
  rating_value: 'Value for money',
  rating_ease: 'Ease of use',
  rating_features: 'Features',
  rating_support: 'Customer support',
}

/** @type {import('./types').default} */
const RatingBreakdownTooltip = ({ children, ratings }) => {
  const [tooltipPos, setTooltipPos] = useState(0)
  const ref = useRef(null)

  useIsomorphicLayoutEffect(() => {
    setTooltipPos({ left: ref?.current?.offsetWidth / 2 - 326 / 2, top: ref?.current?.offsetHeight + 5 })
  }, [])

  return (
    <HoverEvent
      className={clsx('RatingBreakdownTooltip', classes.tooltip)}
      role="tooltip"
      event={{
        name: 'engagement_hover',
        engagementDetails: 'hover_product-rating',
        engagementDestination: 'show_rating-breakdown',
        engagementComponent: `product_reviews`,
      }}
    >
      <span ref={ref} className={classes.childContainer}>
        {children}
      </span>
      <div className={classes.tooltipContentWrapper} style={{ left: `${tooltipPos.left}px` }}>
        <div className={classes.arrow} />
        <div className={classes.tooltipContent}>
          <div className={classes.linksContainer}>
            {Object.entries(ratings)
              .filter(([key]) => key !== 'likelihood_to_recommend')
              .map(([key, value]) => (
                <RatingBreakdownLink
                  key={`review-link-${key}`}
                  disabled={!ratings[key]}
                  starRating={RATINGMAPPING[key]}
                  percentage={formatRatingAverage(value)}
                />
              ))}
          </div>
        </div>
      </div>
    </HoverEvent>
  )
}

export default RatingBreakdownTooltip
